// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1464":"d83d2e4b","1545":"6eac4cb9","4647":"ccdd4f91","6615":"eaacbdfd","7525":"5994f6d4","7954":"d0692f85","8941":"5994f6d4"}[chunkId] + ".chunk.css";
};